import { render, staticRenderFns } from "./AddressBox.vue?vue&type=template&id=7b2e18c4&"
import script from "./AddressBox.vue?vue&type=script&lang=ts&"
export * from "./AddressBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports